<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>Manage {{translate?.setup.users.skills.label.plural}}</h2>
            <span class="sub">Assign {{translate?.setup.users.skills.label.plural | lowercase}} or manage the full {{translate?.setup.users.skills.label.plural | lowercase}} list</span>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body p-0"> 
        <p-tabView class="px-0 tabs-flx-modal" [(activeIndex)]="activeTabIndex">
            <p-tabPanel *ngIf="canAssignSkills" header="Assigned {{translate?.setup.users.skills.label.plural}}">
                <div class="assigned-skills-panel">
                    <div class="selected-skills">
                        <div class="selected-skills__head">
                            <h3>Select {{translate?.setup.users.skills.label.plural}}</h3>
                        </div>
                        <div class="flex-between">
                            <p class="selected-skills__sub">These are the {{translate?.setup.users.skills.label.plural | lowercase}} currently assigned.</p>
                            <span class="selected-skills__count">{{ selectedSkills.length }} {{translate?.general.messages.selected}}</span>
                        </div>

                        <div class="selected-skills__box">
                            <p class="selected-skills__placeholder" *ngIf="!selectedSkills.length">
                                No {{translate?.setup.users.skills.label.plural | lowercase}} selected yet. {{translate?.general.buttons.pick.singular}} from the list below.
                            </p>

                            <span
                                class="skill-chip skill-chip--removable"
                                *ngFor="let skill of selectedSkills; let i = index"
                                [ngStyle]="{ color: skill.color, 'background-color': skill.background }">
                                <span class="skill-chip__label">{{ skill.label }}</span>
                                <i class="fa-solid fa-xmark" (click)="removeSelectedSkill(i)" [pTooltip]="translate?.general.buttons.remove.singular"></i>
                            </span>
                        </div>
                    </div>

                    <div class="available-skills">
                        <div class="available-skills__head flex-between">
                            <h3>{{translate?.general.status.available.singular}} {{translate?.setup.users.skills.label.plural}}</h3>
                            <span class="create-new-link" (click)="activeTabIndex = 1">{{translate?.general.buttons.create.singular}} {{translate?.general.buttons.new.singular}}</span>
                        </div>
                        
                        <span class="p-input-icon-left w-100 py-2">
                             <p-dropdown
                                [(ngModel)]="selectedSkillId"
                                [options]="availableSkillOptions"
                                [placeholder]="translate?.general.messages.none"
                                optionLabel="label"
                                optionValue="id"
                                [filter]="true"
                                appendTo="body"
                                [baseZIndex]="11000"
                                (onChange)="onSkillSelect($event)">
                            </p-dropdown>
                        </span>
                    </div>
                </div>
            </p-tabPanel>

            <!-- Skill Library -->
            <p-tabPanel header="{{translate?.setup.users.skills.label.singular }} Library">
                <div class="skill-library-panel">
                    <div class="skill-library__create">
                        <h3>{{translate?.general.buttons.create.singular}} {{translate?.setup.users.skills.label.plural}}</h3>
                        <p>You're editing the master {{translate?.setup.users.skills.label.singular | lowercase}} list. Colours set here will appear consistently for all users/jobs</p>

                        <div class="skill-library__create-row">
                            <div class="w-100">
                                <input
                                    type="text"
                                    class="mandatory"
                                    placeholder="Enter a {{translate?.setup.users.skills.label.singular }}"
                                    pInputText
                                    [(ngModel)]="newSkillName"
                                    (ngModelChange)="createSkillSubmitted = false"
                                    maxlength="255">
                                <div class="p-error text-10"
                                    *ngIf="createSkillSubmitted && !newSkillName?.trim()">
                                    {{ translate?.general.validationFE.requiredField }}
                                </div>
                            </div>
                            <p-colorPicker appendTo="body" class="color-swatch" [(ngModel)]="newSkillColor"></p-colorPicker>
                            <p-button
                                icon="fa-regular fa-plus"
                                [label]="translate?.general.buttons.add.singular"
                                styleClass="h-32"
                                [disabled]="creatingSkill"
                                (onClick)="onCreateSkill()"></p-button>
                        </div>
                    </div>

                    <div class="skill-library__list">
                        <ng-container *ngFor="let skill of skillLibraryList; let i = index">
                            <!-- VIEW ROW -->
                            <div class="skill-library__row" *ngIf="editingSkillId !== skill?.id">
                                <span class="skill-chip" [ngStyle]="getSkillChipStyles(skill, i)">
                                    <span class="skill-chip__label">
                                    {{ skill?.label || skill }}</span>
                                </span>
                                <div class="skill-library__row-actions">
                                    <span (click)="onEditSkill(skill)">
                                        <i class="fa-regular fa-pencil hvr" [pTooltip]="translate?.general.buttons.edit.singular"></i>
                                    </span>
                                    <span (click)="onDeleteSkill(skill)">
                                        <i class="fa-regular fa-trash hvr-del" [pTooltip]="translate?.general.buttons.delete.singular"></i>
                                    </span>
                                </div>
                            </div>

                            <!-- EDITING ROW STATE -->
                            <div class="skill-library__row skill-library__row--editing" *ngIf="editingSkillId === skill?.id">
                                <div class="w-100">
                                    <input
                                        type="text"
                                        class="mandatory"
                                        pInputText
                                        [(ngModel)]="editSkillName"
                                        (ngModelChange)="editSkillSubmitted = false"
                                        maxlength="255">
                                    <div class="p-error text-10"
                                        *ngIf="editSkillSubmitted && !editSkillName?.trim()">
                                        {{ translate?.general.validationFE.requiredField }}
                                    </div>
                                </div>
                                <p-colorPicker appendTo="body" class="color-swatch" [(ngModel)]="editSkillColor"></p-colorPicker>
                                <div class="skill-library__edit-actions">
                                    <i class="fa-regular fa-check skill-edit-icon skill-edit-icon--save"
                                        [pTooltip]="translate?.general.buttons.save.singular"
                                        (click)="onUpdateSkill(skill)"></i>
                                        
                                    <i class="fa-regular fa-xmark skill-edit-icon skill-edit-icon--cancel"
                                        [pTooltip]="translate?.general.buttons.cancel.singular"
                                        (click)="cancelEditSkill()"></i>

                                    
                                </div>
                            </div>
                        </ng-container>

                        <div class="p-3 text-muted" *ngIf="!skillLibraryList?.length">
                            No {{translate?.setup.users.skills.label.plural | lowercase}} in library
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
     <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button
            *ngIf="canAssignSkills && activeTabIndex === 0"
            type="button"
            [label]="translate?.general.buttons.save.singular"
            styleClass="h-32"
            [disabled]="saving || (!data?.skipUserSave && !selectedSkills?.length)"
            (onClick)="onSave()"></p-button>
    </div>
</div>
